<template>
    <div class="verify-code-div" @click="codeInputFun">
        <ul class="verify-code-num-list">
          <li>
            <span>{{codeArr[0]}}</span>
            <span v-if="isFocus && !codeArr[0]" class="caret"></span>
          </li>
          <li>
            <span>{{codeArr[1]}}</span>
            <span v-if="isFocus && !codeArr[1] && codeArr[0]" class="caret"></span>
          </li>
          <li>
            <span>{{codeArr[2]}}</span>
            <span v-if="isFocus && !codeArr[2] && codeArr[0] && codeArr[1]" class="caret"></span>
          </li>
          <li>
            <span>{{codeArr[3]}}</span>
            <span v-if="isFocus && !codeArr[3] && codeArr[0] && codeArr[1] && codeArr[2]" class="caret"></span>
          </li>
        </ul>
        <input @focus="focus" @blur="blur" ref="codeInput" type="text" class="verify-code-input" unselectable="on" maxlength="4" v-model="code">
    </div>
</template>
<script>
export default {
  name: 'verificatonCode',
  data () {
    return {
      code:'',
      codeArr:[],
      isFocus:false
    }
  },
  watch:{
    code(newVal){
      this.codeArr = String(newVal).split("")
    }
  },
  methods: {
    focus(){
      this.isFocus = true
    },
    blur(){
      this.isFocus = false
    },
    codeInputFun(){
      this.$refs.codeInput.focus()
    },
  }
}
</script>
<style lang="less" scoped>
@keyframes shan {
  to{
    opacity: 0;
  }from{
    opacity: 1;
  }
}
 
.verify-code-div{
  width:100%;
  margin:auto;
  margin-bottom:20px;
  position: relative;
  .verify-code-input{
    width:100%;
    height: 50px;
    line-height:50px;
    // border:1px solid #ccc;
    outline: none;
    color:transparent;
    caret-color:transparent;
    
  }
  .verify-code-num-list{
    width:100%;
    height: 50px;
    background:#fff;
    position: absolute;
    top:0;
    bottom:0;
    left:6px;
    right:0;
    /* margin-left: -140px; */
    text-align: center;
    &:after{
      content:"";
      display: block;
      clear:both;
    }
    li{
      float:left;
      height:50px;
      width: 20%;
      text-align: center;
      line-height:50px;
      display: inline-block;
      background:#f3f7fe;
      /* border-radius:10px; */
      margin-right:20px;
      font-size:20px;
      overflow: hidden;
      .caret{
        margin-top:10px;
        display:inline-block;
        min-width:2px;
        max-width:2px;
        width:2px;
        height:30px;
        background:rgba(0,0,0,.4);
        animation: shan 0.8s infinite;
      }
      &:last-child{
        margin-right:0px;
      }
    }
  }
}
</style>